module.exports = __webpack_public_path__ + "img/loading.5e6408d9.svg";